import React, { useEffect } from 'react'
import { CloseButtonModal } from './CloseButtonModal'
import logger from '../../../../../utils/logger'
import { UserProfileData } from './common-components/UserProfileData'
import { UserContactData } from './common-components/UserContactData'

export const MoreInfo = ({ toggleModal, isActive, userData }) => {



  logger.info('userData more infor: ', userData)

  return (
    <div id="content-4" className={`dto-contacto content ${isActive ? 'active' : ''}`}>

      <CloseButtonModal toggleModal={toggleModal} />


      <div className="header-dto">
        <h4 className="header-nav-title">Mas Información</h4>


        <UserProfileData
          userInfo={userData}
        />


        <UserContactData
          userInfo={userData}
        />

      </div>


      <hr className="under-header" />

      <div className="user-dto d-flex">





        <div className="modal-info-container">

          {userData?.yearOfEnrollment &&

            <div className="today-tpa">

              <div className="iToday-container">
                <span className="material-symbols-outlined notranslate mI-subscription" aria-hidden="true" role="none">today</span>
              </div>


              <div className="year-container">
                <p className="p-year-title">Año en el que realizó la Formación Profesional TPA®</p>
                <hr />
                <p className="p-year">{userData.yearOfEnrollment}</p>
              </div>

            </div>

          }





          {userData?.howMet &&

            <div className="knowing-tpa">
              <div className="iHandshake-container">
                <span className="material-symbols-outlined notranslate mI-subscription" aria-hidden="true" role="none">handshake</span>
              </div>
              <div className="knowing-info">
                <p className="p-knowing-title">Cómo Conociste TPA® y Decidiste Unirte</p>
                <hr />

                <p className="p-how">{userData.howMet}</p>



              </div>
            </div>
          }

          {userData?.formationPlaces[0]?.name &&
            <div className="location-tpa">
              <div className="iLocation-container">
                <span className="material-symbols-outlined notranslate mI-subscription" aria-hidden="true" role="none">location_on</span>
              </div>

              <div className="infoLocation-container">
                <p className="p-location-title">Ubicaciones Preferidas para la Fase Presencial</p>
                <hr />

                <div className="formation-places">


                  <div className="p-ubication">{userData?.formationPlaces[0]?.name}</div>

                </div>

              </div>
            </div>

          }
        </div>








      </div>





    </div>
  )
}
